import React, { useEffect } from "react";
import PropTypes from "prop-types";
import styles from "../../assets/stylesheets/avatar-editor.scss";
import classNames from "classnames";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import configs from "../../utils/configs";
import { Button } from "@fluentui/react-components";
import { Dismiss32Filled } from "@fluentui/react-icons";
import { FormattedMessage, useIntl } from "react-intl";

export default function AvatarCreator({ onClose, className, modal, onCreate }) {
  const avatarsPageUrl = configs.AVATAR_PAGE_URL;

  function src() {
    const branding = configs.APP_NAME;
    return `${avatarsPageUrl}/cartoons?branding=${branding}`;
  }

  const iframeMessageHandler = event => {
    if (event.data?.type === "avatarSuccess") {
      onCreate(event.data.data);
    }

    if (event.origin.includes("readyplayer")) {
      onCreate(event.data);
    }
  };

  const listenIframeMessages = () => {
    window.addEventListener("message", iframeMessageHandler);
  };

  useEffect(() => {
    listenIframeMessages();
    const store = window.APP.store;

    const previouslyEnabled = store.state.preferences.disableIdleDetection;
    store.update({ preferences: { disableIdleDetection: true } });

    // Send auth0Token to iframe after it loads
    const iframe = document.getElementById("avatar-creator-iframe");
    const sendAuthToken = () => {
      const authToken = localStorage.getItem("auth0Token"); // Retrieve token from localStorage
      if (authToken && iframe?.contentWindow) {
        iframe.contentWindow.postMessage({ type: "authToken", token: authToken }, "*"); // Send token
      }
    };

    iframe.onload = sendAuthToken;

    return () => {
      window.removeEventListener("message", iframeMessageHandler);
      if (!previouslyEnabled) {
        store.update({ preferences: { disableIdleDetection: false } });
      }
    };
  }, []);

  const intl = useIntl();

  return (
    <div className={classNames(styles.avatarEditor, className, "custom")} style={modal ? {} : { display: "none" }}>
      <span className={classNames("close-button", modal)}>
        <span className="close-text">
          <FormattedMessage id="room-settings-sidebar.close-button" defaultMessage="Close" />
        </span>
        <Button
          appearance="subtle"
          aria-label={intl.formatMessage({ id: "room-settings-sidebar.close-button", defaultMessage: "Close" })}
          icon={<Dismiss32Filled />}
          onClick={onClose}
        />
      </span>
      <form className="center">
        <iframe
          className="iframe"
          id="avatar-creator-iframe"
          allowusermedia="true"
          allow="camera;microphone"
          src={src()}
          frameBorder="0"
        />
      </form>
    </div>
  );
}

AvatarCreator.propTypes = {
  onClose: PropTypes.func,
  className: PropTypes.string,
  modal: PropTypes.string,
  onCreate: PropTypes.func
};
